import { render, staticRenderFns } from "./CreateOTPFactor.vue?vue&type=template&id=797c20fb&"
import script from "./CreateOTPFactor.vue?vue&type=script&lang=js&"
export * from "./CreateOTPFactor.vue?vue&type=script&lang=js&"
import style0 from "./CreateOTPFactor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports